import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { resolveStudioName } from './studioNameResolver';

// Component to make dancer names clickable
export function ClickableDancerName({ name, style = {}, children, ...props }) {
  if (!name) return children || name;
  
  return (
    <Link 
      to={`/dancer/${encodeURIComponent(name)}`}
      style={{ 
        color: '#0066cc', 
        textDecoration: 'none',
        fontWeight: 'inherit',
        ...style
      }}
      onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
      onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
      {...props}
    >
      {children || name}
    </Link>
  );
}

// Component to make studio names clickable with resolved display names
export function ClickableStudioName({ name, dancerName = null, discipline = null, style = {}, children, ...props }) {
  const [resolvedName, setResolvedName] = useState(name);
  
  useEffect(() => {
    if (name) {
      resolveStudioName(name, dancerName, discipline).then(setResolvedName);
    }
  }, [name, dancerName, discipline]);
  
  if (!name) return children || name;
  
  return (
    <Link 
      to={`/studio/${encodeURIComponent(name)}`} // Use original name for routing
      style={{ 
        color: '#0066cc', 
        textDecoration: 'none',
        fontWeight: 'inherit',
        ...style
      }}
      onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
      onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
      title={name !== resolvedName ? `Originally: ${name}` : ''}
      {...props}
    >
      {children || resolvedName} {/* Display resolved name */}
    </Link>
  );
}

// Higher-order function to automatically detect and make names clickable in text
export function makeNamesClickable(text, dancers = [], studios = []) {
  if (!text || typeof text !== 'string') return text;
  
  let result = text;
  
  // Replace dancer names
  dancers.forEach(dancer => {
    const regex = new RegExp(`\\b${dancer.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
    result = result.replace(regex, (match) => {
      return `<a href="/dancer/${encodeURIComponent(dancer)}" style="color: #0066cc; text-decoration: none;" onmouseenter="this.style.textDecoration='underline'" onmouseleave="this.style.textDecoration='none'">${match}</a>`;
    });
  });
  
  // Replace studio names
  studios.forEach(studio => {
    const regex = new RegExp(`\\b${studio.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
    result = result.replace(regex, (match) => {
      return `<a href="/studio/${encodeURIComponent(studio)}" style="color: #0066cc; text-decoration: none;" onmouseenter="this.style.textDecoration='underline'" onmouseleave="this.style.textDecoration='none'">${match}</a>`;
    });
  });
  
  return <span dangerouslySetInnerHTML={{ __html: result }} />;
}
